import { Grid, Skeleton } from "@mui/material";
import React from "react";

function TableShimmerEffect(props) {
  const { tableColums } = props;
  return (
    <Grid style={{ marginTop: "30px" }}>
      <Grid style={{ margin: "10px 0", display: "flex", gap: "10px" }}>
        {tableColums.map((_, index) => (
          <Skeleton key={index} variant="rect" width={"10%"} height={100} />
        ))}
      </Grid>
      <Grid style={{ margin: "10px 0", display: "flex", gap: "10px" }}>
        {tableColums.map((_, index) => (
          <Skeleton key={index} variant="rect" width={"10%"} height={600} />
        ))}
      </Grid>
    </Grid>
  );
}

export default TableShimmerEffect;
